<template>
  <b-row>
    <b-col cols="12" lg="12">
      <label>{{ $t('views.exsbdocument.form.allowedMaxSize') }}: <b>20MB</b></label>
      <b-row v-for="(item, index) in documentsToUpload" v-bind:key="index" :id="'documentToUpload-' + index">
        <b-col cols="12">
          <b-form-group>
            <label>{{ $t('global.title') }}</label>
            <input type="text" class="form-control" v-model="item.title" :placeholder="$t('global.title')">
          </b-form-group>
        </b-col>
        <b-col cols="9">
          <b-form-group>
            <label>{{ $t('views.exsbdocument.form.documentType') }}: </label>
            <model-select :options="documentTypeOptions" v-model="item.documentType"></model-select>
          </b-form-group>
        </b-col>
        <b-col cols="3" v-if="attachToEmail">
          <b-form-checkbox class="mt-4" v-model="item.attachToEmail" :value="1" :unchecked-value="0">
            {{$t("global.attachToEmail")}}
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <b-row>
              <b-col cols="9">
                <label>{{ $t('views.exsbdocument.form.allowedExtensions') }}: {{getAllowedExtensionForItem(item)}} </label>
                <b-form-file multiple :disabled="item.uploadPercentage > 0" browse-text="Przeglądaj" :ref="'file-input' + index"
                             name="document" :accept="getAllowedExtensionForItem(item)" v-model="item.documents"
                             @input="onFilesInput($event, index)"
                             :state="Boolean(item.documents && item.documents.length > 0)"
                             :placeholder="'Przeciągnij i upuść plik lub kliknij przeglądaj'"></b-form-file>
              </b-col>
              <b-col cols="3">
                <b-button :disabled="index === 0 && !fileIsOptional" class="btn-block mt-4" variant="danger" @click="removeItemCollection"><i
                    class="fa fa-trash mr-2"></i>{{$t('buttons.delete')}}
                </b-button>
              </b-col>
            </b-row>
            <Progress v-if="item.uploadPercentage > 0" class="mt-2" type="primary" max="100"
                      :value="item.uploadPercentage"></Progress>
          </b-form-group>
          <hr>
        </b-col>
      </b-row>
      <b-button variant="success" class="mb-2" @click="addItemCollection"><i class="fa fa-plus mr-2"></i>{{$t('views.exsbdocument.form.addNewFilePosition')}}
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import Progress from '@/components/UIComponents/Progress'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'documentsToUploadCollection',
  components: { Progress, ModelSelect },
  props: {
    documentTypeOptions: {},
    documentsToUpload: {},
    fileIsOptional: {},
    attachToEmail: {}
  },
  methods: {
    getAllowedExtensionForItem (item) {
      let documentType = this.documentTypeOptions.find(type => type.value === item.documentType)
      if (documentType && documentType.allowedExtensions) {
        return documentType.allowedExtensions
      }
      return this.$t('views.exsbdocument.form.defaultExtensions')
    },
    addItemCollection (newDocument = null, documentType = null) {
      let newDocumentToUpload = {
        documents: newDocument ? [newDocument] : [],
        document: newDocument,
        uploadPercentage: 0,
        title: '',
        documentType: documentType,
        attachToEmail: 0
      }
      let newIndex = this.documentsToUpload.push(newDocumentToUpload)
      if (newDocument) {
        this.$nextTick(() => {
          this.$refs['file-input' + (newIndex - 1)][0].files = [newDocument]
        })
      }
    },
    async removeItemCollection (itemIndex) {
      this.documentsToUpload.splice(itemIndex, 1)
    },
    onFilesInput (files, index) {
      if (files.length > 1) {
        for (let i in files) {
          if (i === '0' || i === 0) {
            this.documentsToUpload[index].document = files[i]
            this.documentsToUpload[index].documents = [files[i]]
            this.$refs['file-input' + index][0].files = [files[0]]
          } else {
            this.addItemCollection(files[i], this.documentsToUpload[index].documentType)
          }
        }
      } else if (files.length === 1) {
        this.documentsToUpload[index].document = files[0]
        this.documentsToUpload[index].documents = [files[0]]
        this.$refs['file-input' + index][0].files = [files[0]]
      } else {
        this.documentsToUpload[index].document = null
        this.documentsToUpload[index].documents = []
        this.$refs['file-input' + index][0].files = []
      }
      this.$forceUpdate()
    }
  }
}
</script>
